import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import { colors } from '@/styles';
import { Body1, Body2 } from '../blocks';
import { dateFormatter, timeFormatter } from '../formatters';
import { useClientUser } from '@/hooks';

const ClaimNotes = ({ claim, notes }) => {
    const { isOnwardAdmin, accountType } = useClientUser();

    const getNoteLabel = (note) => {
        let source = note.source_user_type || 'Unknown';
        if (source === 'Admin') {
            source = 'Onward';
        }
        let username = note.user?.username;

        return `${source}${username ? ` (${username})` : ''}`;
    };

    const sorted = useMemo(() => {
        return [...notes].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    }, [notes]);

    const filtered = useMemo(() => {
        if (isOnwardAdmin) {
            return sorted;
        }
        return sorted.filter((note) => {
            return !note.private_to || note.private_to.toLowerCase() === accountType?.toLowerCase();
        });
    }, [sorted, isOnwardAdmin, accountType]);

    return (
        <Grid
            container
            direction="column"
            css={css`
                background: white;
                border: 1px solid ${colors.greys.border};
                border-radius: 0.5rem;
                flex-wrap: nowrap;
            `}
        >
            {filtered?.length ? (
                filtered.map((note, i) => (
                    <Grid
                        item
                        key={note.note_id}
                        css={css`
                            padding: 1rem;
                            margin: 0;
                        `}
                    >
                        {i > 0 && (
                            <hr
                                css={css`
                                    margin-top: 0;
                                `}
                            />
                        )}
                        <Grid container direction="row">
                            <Grid item xs={3}>
                                <Grid container direction="column">
                                    <Grid item>
                                        <Body1>{getNoteLabel(note)}</Body1>
                                    </Grid>
                                    {!!note.user?.email && (
                                        <Grid item>
                                            <Body2>{note.user.email}</Body2>
                                        </Grid>
                                    )}
                                    <Grid item>
                                        <Body2>{dateFormatter(note.created_at)}</Body2>
                                    </Grid>
                                    <Grid item>
                                        <Body2>{timeFormatter(note.created_at)}</Body2>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={9}>
                                <Body1>{note.note}</Body1>
                            </Grid>
                        </Grid>
                    </Grid>
                ))
            ) : (
                <Grid
                    item
                    css={css`
                        margin-top: 35px;
                        align-self: center;
                    `}
                >
                    <Body1>You don't have any notes yet.</Body1>
                </Grid>
            )}
        </Grid>
    );
};

export default ClaimNotes;
